jQuery(function($) {
	var $html = $('html').removeClass('no-js');

	$html.deepLinks();
	$('form input[id^="your-name_"]').attr('autocomplete', 'chrome-off');
	
	if(!$.supports.touch) {
		$('select[multiple]').multiselect();
	}

	// ADD ALL YOUR CUSTOM JS THINGS AFTER THIS LINE

});

jQuery(function($) {
	$(window).resize(function() {
		var $parent = $('.posttypelist_machine'),
			per_row = Math.round($parent.width() / $parent.children(':not([data-sticky])').width());

		if(per_row !== 1) {
			$parent.children('[data-sticky]').slideUp(function() {
				$(this).remove();
			});
		}
	});

	$('form').on({
		change: function() {
			if($(this).is(':checked') && $(this).val() === '') { // "all" is selected, deselect everything else
				$(this).siblings('[type="checkbox"]').prop('checked', false);
			}
		}
	}, '.filter_group__control[type="checkbox"]');

	$('.posttypelist_machine').on({
		click: function() {
			var $parent = $(this).parent(),
				$article = $parent.find('.article:not([data-sticky])'),
				$detail = $(this).clone().attr('data-sticky', 1);

			var per_row = Math.round($parent.width() / $(this).width()),
				pos = $article.get().indexOf(this),
				insert_after = Math.min(Math.ceil((pos + 1) / per_row) * per_row, $article.length);

			$detail.attr('data-reference-position', pos);

			if(per_row === 1 && $(this).next().is('[data-sticky]')) {
				$(this).removeClass('active').next().slideUp(function() {
					$(this).remove();
				});
			}
			else {
				$parent.find('[data-sticky]').slideUp(function() {
					$(this).remove();
				});
				$article.removeClass('active');
				$(this).addClass('active');
				$article.eq(insert_after - 1).after($detail.hide());
				$detail.slideDown();
				setTimeout(function() {
					$(document).scrollTop($(this).offset().top - $('.container-header').height());
				}.bind(this), 500);
			}

			return false;
		}
	}, '.article:not([data-sticky])')
		.on({
			click: function() {
				var type = $(this).attr('class'),
					$detail = $(this).parents('.article'),
					$articles = $(this).parents('.posttypelist_machine').find('.article:not([data-sticky])');

				switch (type) {
					case 'prev':
						$articles.eq(parseInt($detail.attr('data-reference-position')) - 1).click();
						break;
					case 'next':
						var next = parseInt($detail.attr('data-reference-position')) + 1;
						if(next >= $articles.length) {
							next = 0;
						}
						$articles.eq(next).click();
						break;
					case 'close':
						$detail.slideUp(function() {
							$(this).remove();
						});
				}

				return false;
			}
		}, '.article[data-sticky] .article__footer a');
});

jQuery(function($) {
	// slider
	$('.posttypelist_slider--yellow, .posttypelist_slider--fullwidth').find('.slide:first-child').each(function() {
		var $svg = $(decodeURIComponent(window.getComputedStyle(this, ':after')
						.backgroundImage.slice(37, -2)))
						.appendTo(this);
	});
});

jQuery(function($) {
	//counter for summarylist
	$('.counter').one('inview', function () {
		var size = $(this).text().split(".")[1] ? $(this).text().split(".")[1].length : 0;
		$(this).prop('counter', 0).animate({
			counter: $(this).text()
		}, {
			duration: 1000,
			easing: 'swing',
			step: function (now) {
				$(this).text(parseFloat(now).toFixed(size));
			}
		});
	});
});

jQuery(function($) {
	var $html = $('html');

	$html.on({
		input: function() {
			var radii = document.diameters[$(this).val()] || [],
				list = '<ul class="diameter"><li>' + radii.join('</li><li>') + '</li></ul>',
				$form = $(this).parents('form'),
				$editor = $($form.next('article').get(0) || $('<article />').attr({
					'class': 'pagecreator_wysiwygeditor col-xs-12 col-sm-12 col-md-7 col-lg-7'
				}).get(0));

			if(!radii.length) return;

			$editor.insertAfter($form).html('<p><strong>Verfügbare Radien</strong></p>' + list);
		}
	}, '.dropdown--diameter')
		.find('.dropdown--diameter').trigger('input');

	$('[data-autocomplete="off"]').each(function() {
		$(this).prop('checked', false);
	});

	new simpleParallax(document.querySelectorAll('.pagecreator_posttypelist--cta section img:not([src*=".svg"])'), {
		scale: 1.5,
		factor: 2.75,
		orientation: 'down'
	});

	function getQueryVariable(variable) {
		var query = window.location.search.substring(1);
		var vars = query.split('&');
		for (var i = 0; i < vars.length; i++) {
			var pair = vars[i].split('=');
			if (decodeURIComponent(pair[0]) === variable) {
				return decodeURIComponent(pair[1]);
			}
		}
	}

	$('select[name*="subject"]').each(function() {
		if(getQueryVariable('subject')) {
			$(this).val(getQueryVariable('subject'));
		}
	});

	$html.on({
		ready: function() {
			$(document).scrollTop($(this).offset().top - $('.container-header').height() - 63);
		}
	}, '.posttypelist_default--none')
});